<template>
  <transition name="vue-toast-opacity">
    <div class="vue-toast_container default">
      <div class="vue-toast_message">
        <span v-html="message"></span>
        <span class="vue-toast_close-btn" v-if="options.closeBtn"></span>
      </div>
    </div>
  </transition>
</template>

<script>
const defaultOptions = {
  theme: 'default', // info warning error success
  timeLife: 3000,
  closeBtn: false
}
export default {
  props: {
    message: {
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    onDestroy: {
      required: true,
      type: Function
    },
    options: {
      type: Object,
      default:defaultOptions
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    theme() {
      console.log(this.options,'options')
      return '_' + this.options.theme
    },
    style() {
      return `transform: translateY(${this.options.directionOfJumping}${this.position * 100}%)`
    },
    fullOptions() {
      return Object.assign({}, defaultOptions, this.options)
    }
  },
  mounted() {
    setTimeout(() => {
      this.isShow = true
    }, 50)
    if (!this.fullOptions.closeBtn) {
      this._startLazyAutoDestroy()
    }
  },
  methods: {
    // Public
    remove() {
      this._clearTimer()
      this.onDestroy()
    },
    // Private
    _startLazyAutoDestroy() {
      this._clearTimer()
      this.timerDestroy = setTimeout(() => {
        this.remove()
      }, this.fullOptions.timeLife)
    },
    _clearTimer() {
      if (this.timerDestroy) {
        clearTimeout(this.timerDestroy)
      }
    },
    _startTimer() {
      if (!this.fullOptions.closeBtn) {
        this._startLazyAutoDestroy()
      }
    },
    _stopTimer() {
      if (!this.options.closeBtn) {
        this._clearTimer()
      }
    }
  }
}
</script>
<style src="./style.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/components/toast/toast_item/index.vue